/* @flow */
import { List } from 'immutable';
import * as ActionTypes from './action-types.js';
import {FETCH_CS_ENCLAVE_SOURCE_MAP, SHOW_ENTIRE_SUMMARY_TOGGLE} from './action-types';

/* Fetches a summary for a report */
export const fetchSummary = (reportId: string): Object => ({ type: ActionTypes.FETCH_SUMMARY, payload: reportId });

export const toggleShowEntireSummary = (payload: Object) => ({
  type: ActionTypes.SHOW_ENTIRE_SUMMARY_TOGGLE,
  payload
});

export const fetchClosedSourceEnclaveSourceMap = (payload: Object) => ({
  type: FETCH_CS_ENCLAVE_SOURCE_MAP,
  payload
});


// WEBPACK FOOTER //
// ./src/app/modules/summaries/actions.js